import { t } from 'i18next'

import { ContactCategory } from '../../../common/types'
import { TContact } from '../../../common/validations/contractContacts'

const isValidLink = (link?: string | null): boolean => {
  let url
  if (!link) return false
  try {
    url = new URL(link)
  } catch (_) {
    return false
  }
  return url.protocol === 'http:' || url.protocol === 'https:'
}

export interface LegalLinks {
  privacyStatement: string | null
  accessibilityStatement: string | null
  termsOfUse: string | null
}

export const resolveLegalLinks = (): LegalLinks => {
  const links: LegalLinks = {
    privacyStatement: t('contact:legal.privacyStatementLink'),
    accessibilityStatement: t('contact:legal.accessibilityStatementLink'),
    termsOfUse: t('contact:legal.termsOfUseLink'),
  }

  // Do not show links if threre are no link values provided:
  if (!isValidLink(links.privacyStatement)) {
    links.privacyStatement = null
  }
  if (!isValidLink(links.accessibilityStatement)) {
    links.accessibilityStatement = null
  }
  if (!isValidLink(links.termsOfUse)) {
    links.termsOfUse = null
  }
  return links
}

export const resolveContacts = (contacts?: TContact[]) => {
  const propertyManager = contacts?.find(
    (c) => c.contactCategory === ContactCategory.PROPERTY_MANAGEMENT
  )
  const propertyMaintenance = contacts?.find(
    (c) => c.contactCategory === ContactCategory.PROPERTY_MAINTENANCE
  )
  const customerService = contacts?.find(
    (c) => c.contactCategory === ContactCategory.CUSTOMER_SERVICE
  )

  return {
    propertyManager,
    propertyMaintenance,
    customerService,
  }
}
